module.exports = __webpack_public_path__ + "static/media/home-orange.c304711a.svg";